import React from 'react';
import { ThemeProvider } from './context/ThemeContext';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Experience from './components/Experience';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ParticleBackground from './components/shared/ParticleBackground';
import CustomCursor from './components/shared/CustomCursor';
import AIAgentFloating from './components/AIAgentFloating';

function App() {
  return (
    <ThemeProvider>
      <div className="relative min-h-screen transition-colors duration-300 bg-parchment dark:bg-void text-gray-900 dark:text-linen">
        <CustomCursor />
        <ParticleBackground />
        <AIAgentFloating />
        <div className="relative z-10">
          <Header />
          <main>
            <Hero />
            <About />
            <Skills />
            <Projects />
            <Experience />
            <Contact />
          </main>
          <Footer />
        </div>
      </div>
    </ThemeProvider>
  );
}

export default App;
